import apis from './apis'

export const registerApi = (Vue, Store) => {
  Vue.prototype.$apis = apis
  Store.$apis = apis
}

export default apis
